import { createAction } from 'redux-actions'

const ns = 'ssoAdmin/'

// Fetch all SSO configs for a company (list view)
export const getCompanySsoConfigs = createAction(`${ns}GET_COMPANY_SSO_CONFIGS`)
export const getCompanySsoConfigsSuccess = createAction(`${ns}GET_COMPANY_SSO_CONFIGS_SUCCESS`)
export const getCompanySsoConfigsFail = createAction(`${ns}GET_COMPANY_SSO_CONFIGS_FAIL`)

// Fetch single SSO config by ssoConfigId (detail view)
export const getCompanySsoConfig = createAction(`${ns}GET_COMPANY_SSO_CONFIG`)
export const getCompanySsoConfigSuccess = createAction(`${ns}GET_COMPANY_SSO_CONFIG_SUCCESS`)
export const getCompanySsoConfigFail = createAction(`${ns}GET_COMPANY_SSO_CONFIG_FAIL`)

// Create new SSO config
export const createCompanySsoConfig = createAction(`${ns}CREATE_COMPANY_SSO_CONFIG`)
export const createCompanySsoConfigSuccess = createAction(`${ns}CREATE_COMPANY_SSO_CONFIG_SUCCESS`)
export const createCompanySsoConfigFail = createAction(`${ns}CREATE_COMPANY_SSO_CONFIG_FAIL`)

// Update existing SSO config
export const updateCompanySsoConfig = createAction(`${ns}UPDATE_COMPANY_SSO_CONFIG`)
export const updateCompanySsoConfigSuccess = createAction(`${ns}UPDATE_COMPANY_SSO_CONFIG_SUCCESS`)
export const updateCompanySsoConfigFail = createAction(`${ns}UPDATE_COMPANY_SSO_CONFIG_FAIL`)

// Delete SSO config by ssoConfigId
export const deleteCompanySsoConfig = createAction(`${ns}DELETE_COMPANY_SSO_CONFIG`)
export const deleteCompanySsoConfigSuccess = createAction(`${ns}DELETE_COMPANY_SSO_CONFIG_SUCCESS`)
export const deleteCompanySsoConfigFail = createAction(`${ns}DELETE_COMPANY_SSO_CONFIG_FAIL`)

// Navigate to config detail view (null = back to list)
export const setSelectedSsoConfig = createAction(`${ns}SET_SELECTED_SSO_CONFIG`)

// SCIM actions
export const enableScim = createAction(`${ns}ENABLE_SCIM`)
export const enableScimSuccess = createAction(`${ns}ENABLE_SCIM_SUCCESS`)
export const enableScimFail = createAction(`${ns}ENABLE_SCIM_FAIL`)

export const disableScim = createAction(`${ns}DISABLE_SCIM`)
export const disableScimSuccess = createAction(`${ns}DISABLE_SCIM_SUCCESS`)
export const disableScimFail = createAction(`${ns}DISABLE_SCIM_FAIL`)

export const regenerateScimToken = createAction(`${ns}REGENERATE_SCIM_TOKEN`)
export const regenerateScimTokenSuccess = createAction(`${ns}REGENERATE_SCIM_TOKEN_SUCCESS`)
export const regenerateScimTokenFail = createAction(`${ns}REGENERATE_SCIM_TOKEN_FAIL`)

// Company-level SSO settings
export const getCompanySsoSettings = createAction(`${ns}GET_COMPANY_SSO_SETTINGS`)
export const getCompanySsoSettingsSuccess = createAction(`${ns}GET_COMPANY_SSO_SETTINGS_SUCCESS`)
export const getCompanySsoSettingsFail = createAction(`${ns}GET_COMPANY_SSO_SETTINGS_FAIL`)

export const updateCompanySsoSettings = createAction(`${ns}UPDATE_COMPANY_SSO_SETTINGS`)
export const updateCompanySsoSettingsSuccess = createAction(`${ns}UPDATE_COMPANY_SSO_SETTINGS_SUCCESS`)
export const updateCompanySsoSettingsFail = createAction(`${ns}UPDATE_COMPANY_SSO_SETTINGS_FAIL`)

// Keep old action name as alias for backward compatibility
export const configureCompanySso = createCompanySsoConfig
